import {
	ApplicationRef,
	ComponentRef,
	Directive,
	ElementRef,
	EmbeddedViewRef,
	EventEmitter,
	HostListener,
	Input,
	OnDestroy,
	Output,
	ViewContainerRef
} from "@angular/core";
import { BpExtendedTooltipComponent } from "@modules/core/components/bp-extended-tooltip/bp-extended-tooltip.component";

//currently it displays the popup only on top
@Directive({
	selector: "[bpExtendedTooltip]",
	standalone: false
})
/*eslint-disable @typescript-eslint/no-explicit-any*/
export class BpExtendedTooltipDirective implements OnDestroy {
	@Input() tooltip = "";
	@Input() actionButtonName = "";
	@Output() onActionButtonClicked = new EventEmitter<void>();
	private timeoutId: number = undefined;

	private componentRef: ComponentRef<any> = null;

	constructor(
		private elementRef: ElementRef,
		private appRef: ApplicationRef,
		private viewContainerRef: ViewContainerRef
	) {}

	@HostListener("mouseenter")
	onMouseEnter(): void {
		if (this.componentRef === null) {
			this.componentRef = this.viewContainerRef.createComponent(BpExtendedTooltipComponent);
			const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
			document.body.appendChild(domElem);
			this.setTooltipComponentProperties();
		}
	}

	private setTooltipComponentProperties(): void {
		if (this.componentRef !== null) {
			this.componentRef.instance.onMouseEnter.subscribe(() => window.clearTimeout(this.timeoutId));
			this.componentRef.instance.onMouseLeave.subscribe(() => this.destroy());
			this.componentRef.instance.tooltip = this.tooltip;
			this.componentRef.instance.actionButtonName = this.actionButtonName;
			this.componentRef.instance.onActionButtonClicked.subscribe(() => this.onActionButtonClicked.emit());
			const { right, left, top } = this.elementRef.nativeElement.getBoundingClientRect();
			this.componentRef.instance.left = Math.round((right - left) / 2 + left);
			this.componentRef.instance.top = Math.round(top);
		}
	}

	@HostListener("mouseleave")
	public close(): void {
		this.timeoutId = window.setTimeout(() => this.destroy(), 300);
	}

	ngOnDestroy(): void {
		this.destroy();
	}

	destroy(): void {
		if (this.componentRef !== null) {
			this.appRef.detachView(this.componentRef.hostView);
			this.componentRef.destroy();
			this.componentRef = null;
		}
	}
}
